import { render, staticRenderFns } from "./uiDevider.vue?vue&type=template&id=50a74388&scoped=true"
import script from "./uiDevider.vue?vue&type=script&lang=js"
export * from "./uiDevider.vue?vue&type=script&lang=js"
import style0 from "./uiDevider.vue?vue&type=style&index=0&id=50a74388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a74388",
  null
  
)

export default component.exports